(() => {
  let _debounce = null;
  let _removalTimer = null;
  let _isRemoving = false;

  const getThresholds = () => {
    const bar = document.getElementById('tester-progress-bar');
    if (bar?.dataset.thresholdFs) {
      const symbol = bar.dataset.currencySymbol || '€';
      return {
        freeShipping: parseInt(bar.dataset.thresholdFs, 10),
        tier1:        parseInt(bar.dataset.thresholdT1, 10),
        tier2:        parseInt(bar.dataset.thresholdT2, 10),
        isUK:         symbol === '£',
        symbol,
      };
    }
    const s = window.theme?.shopSettings;
    const isUK = s?.isoCode === 'GBP';
    const isEU = s?.isoCode === 'EUR';
    const t = s?.testerGift ?? {};
    return {
      freeShipping: isUK ? (t.freeShippingUK ?? 12000) : isEU ? (t.freeShippingEU ?? 9000) : 0,
      tier1:        isUK ? (t.tier1UK  ?? 15000) : (t.tier1EU  ?? 17000),
      tier2:        isUK ? (t.tier2UK  ?? 19000) : (t.tier2EU  ?? 21000),
      isUK,
      symbol: isUK ? '£' : '€',
    };
  };

  const _tagCache = {};

  const getTagMap = () => {
    const el = document.getElementById('cart-product-tags');
    if (el) {
      try { Object.assign(_tagCache, JSON.parse(el.textContent)); } catch { /* silent */ }
    }
    return _tagCache;
  };

  const calcQualifyingSubtotal = (items, tagMap) =>
    items.reduce((sum, item) => {
      const tags = tagMap[item.product_id] ?? [];
      if (tags.includes('tester-gift') || tags.includes('travel-set')) return sum;
      return sum + item.final_line_price;
    }, 0);

  const calcShippingSubtotal = (items, tagMap) =>
    items.reduce((sum, item) => {
      const tags = tagMap[item.product_id] ?? [];
      if (tags.includes('tester-gift')) return sum;
      return sum + item.final_line_price;
    }, 0);

  const calcTier = (subtotal, { tier1, tier2 }) => {
    if (subtotal >= tier2) return 2;
    if (subtotal >= tier1) return 1;
    return 0;
  };

  const updateProgressBar = (subtotal, thresholds, tier, testerCount, phase) => {
    const msgs   = document.querySelectorAll('.cart-miniature-bar__message');
    const tracks = document.querySelectorAll('.cart-miniature-bar__track');
    if (!msgs.length && !tracks.length) return;

    document.querySelectorAll('.cart-miniature-bar').forEach(el => {
      el.dataset.phase = phase;
    });

    const { symbol, tier1, tier2, freeShipping } = thresholds;
    let pct, text;

    if (phase === 'shipping') {
      pct  = Math.min(subtotal / freeShipping, 1);
      const diff = Math.ceil((freeShipping - subtotal) / 100);
      text = `Add ${symbol}${diff} more for free shipping`;
    } else if (tier === 0) {
      pct  = Math.min((subtotal - freeShipping) / (tier1 - freeShipping), 1);
      const diff = ((tier1 - subtotal) / 100).toFixed(2);
      text = `Spend another ${symbol}${diff} to qualify for a Miniature`;
    } else if (tier === 1) {
      pct  = Math.min((subtotal - tier1) / (tier2 - tier1), 1);
      const diff = ((tier2 - subtotal) / 100).toFixed(2);
      text = testerCount === 1
        ? `Your Miniature is included. Add ${symbol}${diff} more to unlock a second`
        : `You can choose 1 Miniature. Add ${symbol}${diff} more - select 2`;
    } else {
      pct  = 1;
      if (testerCount >= 2)      text = 'Two complimentary testers are included';
      else if (testerCount === 1) text = 'Your complimentary tester is included. Add another one';
      else                        text = 'Choose 2 miniatures';
    }

    const widthVal = `${(pct * 100).toFixed(2)}%`;
    tracks.forEach(track => {
      track.innerHTML = `<div class="cart-miniature-bar__fill" style="width:${widthVal}">${widthVal}</div>`;
    });
    msgs.forEach(el => { el.textContent = text; });
  };

  const updateShippingStatus = (subtotal, thresholds) => {
    const statusEls = document.querySelectorAll('.cart-shipping-status');
    if (!statusEls.length) return;

    const { freeShipping, symbol, isUK } = thresholds;

    if (freeShipping === 0) {
      statusEls.forEach(el => { el.style.display = 'none'; });
      return;
    }

    statusEls.forEach(el => { el.style.display = ''; });

    const textEls = document.querySelectorAll('.cart-shipping-status__text');
    if (!textEls.length) return;

    if (subtotal >= freeShipping) {
      const label = isUK ? 'UK SHIPPING UNLOCKED' : 'STANDARD SHIPPING UNLOCKED';
      textEls.forEach(el => {
        el.innerHTML = `<span class="cart-shipping-status__bold">FREE</span><span class="cart-shipping-status__regular"> ${label}</span>`;
      });
    } else {
      const diff = ((freeShipping - subtotal) / 100).toFixed(2);
      textEls.forEach(el => {
        el.innerHTML = `<span class="cart-shipping-status__regular">ADD </span><span class="cart-shipping-status__bold">${symbol}${diff}</span><span class="cart-shipping-status__regular"> MORE FOR FREE STANDARD SHIPPING</span>`;
      });
    }
  };

  const updateSelectButtons = (tier, testerCount, maxAllowed, phase) => {
    const cmBars  = document.querySelectorAll('.cm-bar');
    const trigger = document.getElementById('miniature-select-trigger');
    const barBtn  = document.querySelector('.cm-bar__btn[data-modal-trigger]');

    if (phase === 'shipping') {
      cmBars.forEach(el => { el.style.display = 'none'; });
      if (trigger) trigger.style.display = 'none';
      return;
    }

    cmBars.forEach(el => { el.style.display = ''; });
    if (trigger) trigger.style.display = '';

    const locked    = tier === 0;
    const allFilled = !locked && testerCount >= maxAllowed;

    for (const btn of [trigger, barBtn]) {
      if (!btn) continue;
      btn.disabled = locked;
      btn.setAttribute('aria-disabled', String(locked));
    }

    cmBars.forEach(el => el.setAttribute('aria-disabled', String(locked)));

    const textEl = trigger?.querySelector('.cart-miniature-select__text');
    if (textEl) textEl.textContent = allFilled ? 'Change miniature →' : 'Choose your miniature →';

    if (barBtn) barBtn.textContent = allFilled ? 'CHANGE MINIATURE' : 'SELECT YOUR MINIATURE';

    document.querySelectorAll('.cm-bar__title').forEach(el => {
      const textNode = el.firstChild;
      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        textNode.textContent = allFilled ? 'Change miniature' : 'Choose your Miniature';
      }
    });
  };

  const updateModal = (tier) => {
    const modal = document.getElementById('miniature-select-modal');
    if (!modal) return;
    modal.dataset.maxTesters = tier;

    if (tier < 2) {
      modal.querySelectorAll('.msm__radio:checked')
        .forEach((el, i) => { if (i >= tier) el.checked = false; });
    }
  };

  const getTesterVariantIds = () => {
    const modal = document.getElementById('miniature-select-modal');
    if (!modal) return new Set();
    return new Set(
      [...modal.querySelectorAll('.msm__card')]
        .map(c => Number(c.dataset.variantId))
        .filter(Boolean)
    );
  };

  const getTesterItems = (items) => {
    const ids = getTesterVariantIds();
    return ids.size ? items.filter(i => ids.has(i.variant_id)) : [];
  };

  const showToast = (message) => {
    let toast = document.getElementById('tester-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tester-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('is-visible'), 5000);
  };

  const removeExcessTesters = async (testerItems, maxAllowed) => {
    _isRemoving = true;
    try {
      for (const item of testerItems.slice(maxAllowed)) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      }
      const cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl && typeof cartItemsEl.refreshCartSections === 'function') {
        await cartItemsEl.refreshCartSections();
      } else if (typeof refreshCartSectionsGlobal === 'function') {
        await refreshCartSectionsGlobal();
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch {
      // silent
    } finally {
      _isRemoving = false;
    }
  };

  const fetchMissingTags = async (items, tagMap) => {
    const unknown = items.filter(i => !tagMap[i.product_id] && i.handle);
    if (!unknown.length) return;
    await Promise.all(unknown.map(async item => {
      try {
        const prod = await fetch(`/products/${item.handle}.js`).then(r => r.json());
        tagMap[item.product_id] = prod.tags || [];
      } catch { /* silent */ }
    }));
  };

  const recalculate = async () => {
    const thresholds = getThresholds();
    try {
      const cart       = await fetch('/cart.js').then(r => r.json());
      const tagMap     = getTagMap();
      await fetchMissingTags(cart.items, tagMap);
      const qualifying = calcQualifyingSubtotal(cart.items, tagMap);
      const shipping   = calcShippingSubtotal(cart.items, tagMap);
      const tier       = calcTier(qualifying, thresholds);
      const testerItems = getTesterItems(cart.items);

      window.__testerGiftCart = cart.items;

      const phase = shipping < thresholds.freeShipping ? 'shipping' : 'tester';
      const barSubtotal = phase === 'shipping' ? shipping : qualifying;
      updateProgressBar(barSubtotal, thresholds, tier, testerItems.length, phase);
      updateShippingStatus(shipping, thresholds);
      updateSelectButtons(tier, testerItems.length, tier, phase);
      updateModal(tier);

      const count = cart.item_count;
      document.querySelectorAll('.cart-miniature-bar__count').forEach(el => {
        el.textContent = `${count} ${count === 1 ? 'ITEM' : 'ITEMS'}`;
      });

      if (_isRemoving || testerItems.length <= tier) return;

      const excess    = testerItems.length - tier;
      const threshold = tier === 0 ? thresholds.tier1 : thresholds.tier2;
      const msg = excess === 1
        ? `Your subtotal dropped below ${thresholds.symbol}${threshold / 100} — 1 complimentary tester will be removed from your cart`
        : `Your subtotal dropped below ${thresholds.symbol}${threshold / 100} — ${excess} complimentary testers will be removed from your cart`;

      showToast(msg);
      clearTimeout(_removalTimer);
      _removalTimer = setTimeout(() => removeExcessTesters(testerItems, tier), 3000);
    } catch {
      // silent
    }
  };

  const applyFromCache = () => {
    if (!window.__testerGiftCart) return false;
    const thresholds  = getThresholds();
    const tagMap      = getTagMap();
    const qualifying  = calcQualifyingSubtotal(window.__testerGiftCart, tagMap);
    const shipping    = calcShippingSubtotal(window.__testerGiftCart, tagMap);
    const tier        = calcTier(qualifying, thresholds);
    const testerItems = getTesterItems(window.__testerGiftCart);

    const phase = shipping < thresholds.freeShipping ? 'shipping' : 'tester';
    const barSubtotal = phase === 'shipping' ? shipping : qualifying;
    updateProgressBar(barSubtotal, thresholds, tier, testerItems.length, phase);
    updateShippingStatus(shipping, thresholds);
    updateSelectButtons(tier, testerItems.length, tier, phase);
    updateModal(tier);

    const count = window.__testerGiftCart.reduce((s, i) => s + i.quantity, 0);
    document.querySelectorAll('.cart-miniature-bar__count').forEach(el => {
      el.textContent = `${count} ${count === 1 ? 'ITEM' : 'ITEMS'}`;
    });
    return true;
  };

  document.addEventListener('cart:updated', (e) => {
    clearTimeout(_debounce);
    clearTimeout(_removalTimer);
    try {
      const cartRaw = e?.detail?.cart;
      const parsed  = typeof cartRaw === 'string' ? JSON.parse(cartRaw) : cartRaw;
      if (parsed && Array.isArray(parsed.items)) {
        window.__testerGiftCart = parsed.items;
        applyFromCache();
        _debounce = setTimeout(recalculate, 1500);
        return;
      }
    } catch { /* fall through */ }
    recalculate();
  });

  document.addEventListener('cartdrawer:opened', () => {
    applyFromCache();
    recalculate();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recalculate);
  } else {
    recalculate();
  }
})();
